import { render, staticRenderFns } from "./NetworkStatusBanner.vue?vue&type=template&id=321e029c&scoped=true&"
import script from "./NetworkStatusBanner.vue?vue&type=script&lang=js&"
export * from "./NetworkStatusBanner.vue?vue&type=script&lang=js&"
import style0 from "./NetworkStatusBanner.vue?vue&type=style&index=0&id=321e029c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321e029c",
  null
  
)

export default component.exports